// extracted by mini-css-extract-plugin
export default {"nav-button":"savior-desc-modal_nav-button__6p-9H","prev":"savior-desc-modal_prev__zxowl","next":"savior-desc-modal_next__d18Ir"};